import { render, staticRenderFns } from "./ShenPiJiGou.vue?vue&type=template&id=9b0b6a46&scoped=true&"
import script from "./ShenPiJiGou.vue?vue&type=script&lang=js&"
export * from "./ShenPiJiGou.vue?vue&type=script&lang=js&"
import style0 from "./ShenPiJiGou.vue?vue&type=style&index=0&id=9b0b6a46&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b0b6a46",
  null
  
)

export default component.exports